/** @jsx jsx */
import { BaseButton, Button, Icon } from "@cd2/components/build/es6"
import { IComponentProp, IComponentProps } from "@cd2/tools/build/es6"
import { jsx } from "@emotion/core"
import { brandColors } from "../EOSThemeProvider"
import { useTheme } from "@cd2/theme/build/es6"

export function CustomerButton(
  props: IComponentProps<typeof Button> & {
    withShadow?: boolean
    renderLeft?: IComponentProp<typeof BaseButton, "renderLeft">
    renderRight?: IComponentProp<typeof BaseButton, "renderRight">
    type?: IComponentProp<typeof BaseButton, "type">
    thin?: boolean
    weight?: number
  },
) {
  const theme = useTheme()
  const buttonColor = props.buttonColor || brandColors.mint
  return (
    <BaseButton
      children={props.children}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
      theme={{
        borderRadius: 0,
        padding: { sides: props.thin ? 14 : 24, topAndBottom: 10 },
        borderColor: "transparent",
        buttonColor: buttonColor,
        color: props.color,
        hoverColor: props.hoverColor,
        boxShadow: props.withShadow ? theme.button.boxShadow : "none",
        weight: props.weight || 800,
        ...(props.extendTheme ?? {}),
      }}
      renderLeft={props.leftIcon ? () => <Icon icon={props.leftIcon as any} /> : props.renderLeft}
      renderRight={
        props.rightIcon ? () => <Icon icon={props.rightIcon as any} /> : props.renderRight
      }
      buttonStyle={props.buttonStyle}
      className={props.className}
    />
  )
}
